import Views from '../../views/host/hostRegistration/HostRegistrationViews';
import GetInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import {
  eligibilityIsComplete, meetInfoIsComplete, restrictionsIsComplete,
  sessionsIsComplete, ageGroupsIsComplete, timeStandardsIsComplete, eventsIsComplete
} from './LeftNavValidation';

const getEvents = (viewName, route, omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, SCY_COURSE_ID, SCM_COURSE_ID, LCM_COURSE_ID,
  restrictionsRoutePermission, eligibilityRoutePermission, meetInfoRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION) => {
  const isCurrent = viewName === Views.OME_MEET_EVENTS;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, meetInfoRoutePermission);
  const isEligibilityComplete = eligibilityIsComplete(omeMeetStateObjData, omeMeetEntryStateObjData, eligibilityRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION);
  const isRestrictionsComplete = restrictionsIsComplete(omeMeetStateObjData, restrictionsRoutePermission);
  const isSessionsComplete = sessionsIsComplete(meetStateObjData);
  const isAgeGroupsComplete = ageGroupsIsComplete(omeMeetStateObjData);
  const isTimeStandardsComplete = timeStandardsIsComplete(omeMeetStateObjData);

  const arePrerequisitesDone = isMeetInfoComplete === true && isEligibilityComplete === true
    && isRestrictionsComplete === true && isSessionsComplete === true
    && isAgeGroupsComplete === true && isTimeStandardsComplete === true;

  const isComplete = isMeetInfoComplete === true && isEligibilityComplete === true && isTimeStandardsComplete === true
    && isRestrictionsComplete === true && isSessionsComplete === true
    && isAgeGroupsComplete === true && eventsIsComplete(omeMeetStateObjData, SCY_COURSE_ID, SCM_COURSE_ID, LCM_COURSE_ID);

  const item = route === '' ? GetInitialStateOmeRoute(Views.OME_MEET_EVENTS) : getInitialStateMeetRoute(Views.OME_MEET_EVENTS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getEvents;